export const handleOnClose = (callback) => (event, reason) => {
    if (callback && event && reason !== 'backdropClick') {
        callback(event);
    }
};